import http_request from './http_request'
import config from 'config'

function getCurrentMicrotime() {
	return http_request.get(`${config.api}microtime`)
		.send()
}

export default {
	getCurrentMicrotime,
}
